import type { GraphicsCapabilities } from '../policies/render-quality.policy';

interface NavigatorWithMemory extends Navigator {
  deviceMemory?: number;
}

/** What this browser says about its graphics, read once from a throwaway canvas. jsdom and browsers without WebGL report none. */
export function readGraphicsCapabilities(): GraphicsCapabilities {
  const nav = navigator as NavigatorWithMemory;
  const base = { deviceMemoryGb: nav.deviceMemory, logicalCores: nav.hardwareConcurrency || undefined };
  if (typeof WebGLRenderingContext === 'undefined') return { hasWebGl: false, hasMajorPerformanceCaveat: false, ...base };
  const probe = document.createElement('canvas');
  const fast = probe.getContext('webgl2', { failIfMajorPerformanceCaveat: true }) ?? probe.getContext('webgl', { failIfMajorPerformanceCaveat: true });
  const context = fast ?? document.createElement('canvas').getContext('webgl2') ?? document.createElement('canvas').getContext('webgl');
  if (!context) return { hasWebGl: false, hasMajorPerformanceCaveat: false, ...base };
  const debug = context.getExtension('WEBGL_debug_renderer_info');
  const gpuRenderer = debug ? String(context.getParameter(debug.UNMASKED_RENDERER_WEBGL)) : undefined;
  context.getExtension('WEBGL_lose_context')?.loseContext();
  return { hasWebGl: true, hasMajorPerformanceCaveat: !fast, gpuRenderer, ...base };
}
